import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { CablePlanDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchCablePlans } from "../../../../features/auth/store/cablePlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import CablePlans from "./Cable";

const CablePlanRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [selectedCablePlan, setSelectedCablePlan] = useState<Product | null>(
    null,
  );
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { cablePlans, loading, error } = useSelector(
    (state: RootState) => state.cablePlans,
  );

  useEffect(() => {
    const filters: any = {};

    // Only add status filter if it's not empty
    if (statusFilter && statusFilter !== "") {
      filters.status = statusFilter;
    }
    if (searchTerm && searchTerm !== "") {
      filters.search = searchTerm;
    }

    dispatch(fetchCablePlans(filters));
  }, [dispatch, statusFilter, searchTerm]);

  // Transform DataPlan to Product - ensuring all required fields are present

  const handleCablePlanClick = (dataPlan: Product) => {
    setSelectedCablePlan(dataPlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedCablePlan(null);
  };

  if (showDetailView && selectedCablePlan) {
    return (
      // <ProductDetailView dataPlan={selectedDataPlan} onBack={handleBackToList} />
      <CablePlanDetailView
        cablePlan={{
          ...selectedCablePlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <CablePlans
      cablePlans={cablePlans || []}
      loading={loading}
      error={error}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onCablePlanClick={handleCablePlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
    />
  );
};

export default CablePlanRouter;
